import type {ConnectElementConfig} from '../ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

export const TerminalHardwareOrdersConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "terminalHardwareOrders" */
      '../../../components/Terminal/HardwareOrders/HardwareOrders/TerminalHardwareOrders'
    ),
  teamOwner: 'terminal-logistics-eng',
  sentryTeam: 'terminal_hardware_orders',
  enabledKey: 'terminal_hardware_orders',
  enabledOverrideFlag: ComponentOverrideFlag.terminal_hardware_orders,
  releaseState: 'preview',
  description: 'Shows a list of terminal hardware orders.',
  friendlyName: 'Terminal Hardware Orders',
  docSitePath:
    '/connect/supported-embedded-components/terminal-hardware-orders',
  syntheticTestInfo: {
    testUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/terminal-hardware-orders',
  },
};
